module.exports = __webpack_public_path__ + "static/media/17.89a17b31.mp3";